import Layout from '@/layout'
const permissionRouter = {
  path: '/permission',
  component: Layout,
  name: 'permission',
  meta: {
    title: '系统权限管理',
    icon: 'el-icon-setting',
    roles: ['root']
  },
  children: [

    {
      path: 'table',
      name: 'PermissionTable',
      component: () => import('@/views/permission/permissionTable'),
      meta: { title: '系统权限列表', icon: 'el-icon-receiving', roles: ['root', 'editor'], noCache: false }
    }
  ]
}
export default permissionRouter
